export type MediaStreamDump = Readonly<
  Pick<MediaStream, 'id' | 'active'> &
  { tracks: readonly MediaStreamTrackDump[] }
>;

export type MediaStreamTrackDump = Readonly<Pick<
  MediaStreamTrack,
  'id' | 'kind' | 'label' | 'muted' | 'enabled' | 'readyState'
>>;

// Limit the input to only what's used
type MediaStreamDumpInput = Readonly<
  Pick<MediaStream, 'id' | 'active'> &
  { getTracks(): readonly MediaStreamTrackDump[] }
>;

/**
 * Dump debugging info of a media stream and its tracks, this is
 * useful in stringification because normally they end up as '{}'.
 */
export default function dumpMediaStream(stream: MediaStreamDumpInput): MediaStreamDump {
  const { id, active } = stream;

  return {
    id,
    active,
    tracks: stream.getTracks().map(dumpMediaStreamTrack),
  };
}

export function dumpMediaStreamTrack(
  { id, kind, label, muted, enabled, readyState }: MediaStreamTrackDump,
): MediaStreamTrackDump {
  return { id, kind, label, muted, enabled, readyState };
}
